module.exports = __webpack_public_path__ + "static/media/apple.7ac00791.svg";